import React from 'react';
import './pages.css';
import ContentBox from '../components/ContentBox';

const Home = () => {
  return (
    <div>
      <ContentBox>
        <h2>Welcome to IESG</h2>
        <p>Your content here...</p>
      </ContentBox>

      <ContentBox>
        <h2>Our Services</h2>
        <p>Another section of content...</p>
      </ContentBox>
    </div>
  );
}

export default Home; 